var ui_templates = require("ui-templates");
var PackageMasterTemplate = require('./package__master__template.js');

/**
 * Creates a Master Layout
 *
 * @implements {Layout}
 * @param {String} [target=body] - Selector string that defines the target
 * @returns {Master}
 * @exports LayoutCircuits
 */

var PackageMasterLayout = function(target, noNav){
    return new PackageMasterTemplate({
        target: target,
        fields: {
            'noNav': noNav
        }
    });
}

module.exports = PackageMasterLayout;